// import React, { useContext, useEffect, useState } from "react";
// import { GroupListMisApi } from "../../../../../../api/Api";
// import { Refresh } from "@mui/icons-material";
// import IconButton from "@mui/material/IconButton";
// import { useNavigate } from "react-router-dom";
// import { AppThemeContext } from "../../../../../../context/AppThemeContext";
// import { getDateTimeForDashboardTab1 } from "../businessGroupListRight/BusinessGroupListRight";
// import { IoMdRefresh } from "react-icons/io";
// import * as XLSX from "xlsx";

// export default function BusinessGroupMis() {
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const [logData, setLogData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [searchQuery, setSearchQuery] = useState("");
//     const navigate = useNavigate();

//     const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
//     const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

//     const [currentPage, setCurrentPage] = useState(1);
//     const rowsPerPage = 5;

//     // ✅ fetch API dynamically with latest StartDate & EndDate
//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);
//         try {
//             const res = await GroupListMisApi({
//                 User_ID: localStorage.getItem("LOGIN_ID") || "",
//                 SKey: localStorage.getItem("SS_KEY") || "",
//                 DT1: StartDate,
//                 DT2: EndDate,
//             });

//             if (res?.GROUP_LIST && Array.isArray(res.GROUP_LIST)) {
//                 setLogData(res.GROUP_LIST);
//                 setFilteredData(res.GROUP_LIST);
//             } else {
//                 setLogData([]);
//                 setFilteredData([]);
//             }
//         } catch (err) {
//             console.error("Error fetching data:", err);
//             setError("Failed to fetch data.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     // ✅ call API whenever StartDate or EndDate changes
//     useEffect(() => {
//         fetchLogData();
//     }, [Credential.User_ID, StartDate, EndDate]);

//     const handleSearch = () => {
//         const filtered = logData.filter((item) =>
//             Object.values(item).join(" ").toLowerCase().includes(searchQuery.toLowerCase())
//         );
//         setFilteredData(filtered);
//         setCurrentPage(1);
//     };

//     const indexOfLastRow = currentPage * rowsPerPage;
//     const indexOfFirstRow = indexOfLastRow - rowsPerPage;
//     const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);
//     const totalPages = Math.ceil(filteredData.length / rowsPerPage);

//     const handlePageChange = (page) => {
//         if (page >= 1 && page <= totalPages) {
//             setCurrentPage(page);
//         }
//     };

//     const style = {
//         maxWidth: "100px",
//         padding: "4px 8px",
//         fontSize: "0.9rem",
//         borderRadius: "7px",
//     };

//     // Refresh data only when clicking "Show"
//     function onRefreshData() {
//         if (StartDate.length !== 0 && EndDate.length !== 0) {
//             fetchLogData(); // Fetch data only after clicking the button
//         } else {
//             alert("Please provide valid dates");
//         }
//     }

//     // Export to Excel
//     const exportToExcel = () => {
//         const ws = XLSX.utils.json_to_sheet(logData);
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, "Group MIS");
//         XLSX.writeFile(wb, `Group MIS From ${StartDate} To ${EndDate}.xls`);
//     };

//     return (
//         <div className="w-100">
//             <div className="row">
//                 <div className="col-md-12">
//                     {loading && <p>Loading...</p>}
//                     {error && <p style={{ color: "red" }}>{error}</p>}
//                     <div
//                         className="w-100"
//                         style={{ backgroundColor: "#f8f9fa", borderBottom: "2px solid #dee2e6" }}
//                     >
//                         <div className="d-flex justify-content-between align-items-center px-0">
//                             <h6 style={{ margin: 0, fontWeight: "bold", color: "#343a40" }}>
//                                 Group List
//                             </h6>

//                             <div className="d-flex align-items-center">
//                                 &nbsp;&nbsp;
//                                 <label>
//                                     From:&nbsp;
//                                     <input
//                                         type="date"
//                                         value={StartDate}
//                                         onChange={(e) => setStartDate(e.target.value)}
//                                         style={{
//                                             padding: "2px 2px",
//                                             borderRadius: "14px",
//                                             border: "1px solid #ccc",
//                                         }}
//                                     />
//                                 </label>
//                                 <label>
//                                     To:&nbsp;
//                                     <input
//                                         type="date"
//                                         value={EndDate}
//                                         onChange={(e) => setEndDate(e.target.value)}
//                                         style={{
//                                             padding: "2px 2px",
//                                             borderRadius: "14px",
//                                             border: "1px solid #ccc",
//                                         }}
//                                     />
//                                 </label>
//                                 &nbsp;
//                                 <IoMdRefresh onClick={onRefreshData} style={{ fontSize: "1.3rem" }} />
//                                 <input
//                                     type="text"
//                                     className="form-control form-control-sm me-2"
//                                     placeholder="Search..."
//                                     value={searchQuery}
//                                     onChange={(e) => setSearchQuery(e.target.value)}
//                                     style={{ maxWidth: "120px", borderRadius: "7px" }}
//                                 />
//                                 <button
//                                     className="btn-primary btn-sm text-white"
//                                     onClick={handleSearch}
//                                     style={style}
//                                 >
//                                     Search
//                                 </button>&nbsp;
//                                 <button onClick={exportToExcel} style={{backgroundColor: "darkblue",color: "#fff",border: "none", borderRadius: "14px",padding: "4px 9px",cursor: "pointer",fontSize: "13px"}}>
//                                     Excel
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     <div
//                         className="table-responsive"
//                         style={{ border: "1px solid #dee2e6", borderTop: "none" }}
//                     >
//                         <table className="table table-striped">
//                             <thead>
//                                 <tr>
//                                     <th>Sn</th>
//                                     <th>From Date</th>
//                                     <th>To Date</th>
//                                     <th>Company Name/Group Name</th>
//                                     <th>ID</th>
//                                     <th>Address</th>
//                                     <th>KWh</th>
//                                     <th>CUF</th>
//                                     <th>PR</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {currentRows.length > 0 ? (
//                                     currentRows.map((log, index) => (
//                                         <tr key={index}>
//                                             <td>{indexOfFirstRow + index + 1}</td>
//                                             <td>{log.FROM_DATE}</td>
//                                             <td>{log.TO_DATE}</td>
//                                             <td>{log.CompanyName}</td>
//                                             <td>{log.Group_id}</td>
//                                             <td>{log.Address}</td>
//                                             <td>{log.Eng}</td>
//                                             <td>{log.cuf}</td>
//                                             <td>{log.pr}</td>
//                                         </tr>
//                                     ))
//                                 ) : (
//                                     <tr>
//                                         <td colSpan="9" className="text-center">
//                                             No data available
//                                         </td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>

//                     <div className="d-flex justify-content-center my-3">
//                         <button
//                             className="btn btn-secondary btn-sm mx-1"
//                             onClick={() => handlePageChange(currentPage - 1)}
//                             disabled={currentPage === 1}
//                             style={{
//                                 height: "28px",
//                                 backgroundColor: PrimaryColor,
//                                 padding: "2px",
//                                 fontSize: "10px",
//                             }}
//                         >
//                             Previous
//                         </button>
//                         {[...Array(totalPages).keys()].map((num) => (
//                             <button
//                                 key={num}
//                                 className={`btn btn-sm mx-1 ${currentPage === num + 1 ? "btn-primary" : "btn-outline-primary"
//                                     }`}
//                                 onClick={() => handlePageChange(num + 1)}
//                                 style={{
//                                     height: "20px",
//                                     width: "20px",
//                                     padding: "0",
//                                     fontSize: "12px",
//                                 }}
//                             >
//                                 {num + 1}
//                             </button>
//                         ))}
//                         <button
//                             className="btn btn-secondary btn-sm mx-1"
//                             onClick={() => handlePageChange(currentPage + 1)}
//                             disabled={currentPage === totalPages}
//                             style={{
//                                 height: "28px",
//                                 backgroundColor: PrimaryColor,
//                                 padding: "2px",
//                                 fontSize: "10px",
//                             }}
//                         >
//                             Next
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }


import React, { useContext, useEffect, useState } from "react";
import { GroupListMisApi } from "../../../../../../api/Api";
import { Refresh } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import { AppThemeContext } from "../../../../../../context/AppThemeContext";
import { getDateTimeForDashboardTab1 } from "../businessGroupListRight/BusinessGroupListRight";
import { IoMdRefresh } from "react-icons/io";
import * as XLSX from "xlsx";



export default function BusinessGroupMis() {
  const { PrimaryColor } = useContext(AppThemeContext);
  const [logData, setLogData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
  const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;

    // ✅ new state for input box
    const [searchInput, setSearchInput] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

  // ✅ fetch API dynamically with latest StartDate & EndDate
  const fetchLogData = async () => {
    setLoading(true);
    setError(null);
    setLogData([]);
    try {
      const res = await GroupListMisApi({
        User_ID: localStorage.getItem("business_LOGIN_ID") || "",
        SKey: localStorage.getItem("business_SS_KEY") || "",
        DT1: StartDate,
        DT2: EndDate,
      });

      if (res?.GROUP_LIST && Array.isArray(res.GROUP_LIST)) {
        setLogData(res.GROUP_LIST);
        setFilteredData(res.GROUP_LIST);
      } else {
        setLogData([]);
        setFilteredData([]);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ call API whenever StartDate or EndDate changes
  useEffect(() => {
    fetchLogData();
  }, []);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(logData);
    } else {
      const filtered = logData.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
      setFilteredData(filtered);
    }
    setCurrentPage(1);
  }, [searchQuery, logData, StartDate]);
  

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const style = {
    maxWidth: "100px",
    padding: "4px 8px",
    fontSize: "0.9rem",
    borderRadius: "7px",
  };

  // Refresh data only when clicking "Show"
  function onRefreshData() {
    if (StartDate.length !== 0 && EndDate.length !== 0) {
      fetchLogData();
    } else {
      alert("Please provide valid dates");
    }
  }

  // Define static headers
  const tableHeaders = [
    "Sn",
    "From Date",
    "To Date",
    "Company Name/Group Name",
    "ID",
    "Address",
    "Count",
    "KWh",
    "CUF",
    "PR",
  ];

  // If display names are different from keys in `logData`, create a mapping
  const headerKeyMap = {
    "Sn":"",
    "From Date": "FROM_DATE",
    "To Date": "TO_DATE",
    "Company Name/Group Name": "CompanyName",
    "ID": "Group_id",
    "Address": "Address",
    "Count":"COUNT",
    "KWh": "Eng",
    "CUF": "cuf",
    "PR": "pr",
  };

//   const exportToExcel = () => {
//     const filteredExportData = logData.map((item) => {
//       let filteredItem = {};
//       tableHeaders.forEach((header) => {
//         if (header === "Sn") {
//           filteredItem[header] = ""; // skip Sn in Excel
//         } else {
//           const key = headerKeyMap[header];
//           filteredItem[header] = item[key];
//         }
//       });
//       return filteredItem;
//     });

//     const ws = XLSX.utils.json_to_sheet(filteredExportData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Group MIS");
//     XLSX.writeFile(wb, `Group MIS From ${StartDate} To ${EndDate}.xlsx`);
//   };

const exportToExcel = () => {
    const filteredExportData = logData.map((item, index) => {
      let filteredItem = {};
      tableHeaders.forEach((header) => {
        if (header === "Sn") {
          filteredItem[header] = index + 1; // yaha serial number dena
        } else {
          const key = headerKeyMap[header];
          filteredItem[header] = item[key] || "";
        }
      });
      return filteredItem;
    });
  
    const ws = XLSX.utils.json_to_sheet(filteredExportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Group MIS");
    XLSX.writeFile(wb, `Group MIS From ${StartDate} To ${EndDate}.xlsx`);
  };
  
  return (
    <div className="w-100">
      <div className="row">
        <div className="col-md-12">
          {loading && <p>Loading...</p>}
          {error && <p style={{ color: "red" }}>{error}</p>}

          <div
            className="w-100"
            style={{ backgroundColor: "#f8f9fa", borderBottom: "2px solid #dee2e6" }}
          >
            <div className="d-flex justify-content-between align-items-center px-0">
              <h6 style={{ margin: 0, fontWeight: "bold", color: "#343a40" }}>Group List</h6>

              <div className="d-flex align-items-center">
                <label>
                  From:&nbsp;
                  <input
                    type="date"
                    value={StartDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc",
                    }}
                  />
                </label>
                <label>
                  To:&nbsp;
                  <input
                    type="date"
                    value={EndDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc",
                    }}
                  />
                </label>
                &nbsp;
                <IoMdRefresh onClick={onRefreshData} style={{ fontSize: "1.3rem", cursor: "pointer" }} />

                   {/* ✅ search input bound to searchInput */}
                   <input
                  type="text"
                  className="form-control form-control-sm me-2"
                  placeholder="Search..."
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  style={{ maxWidth: "120px", borderRadius: "7px" }}
                />
                <button
                  className="btn-primary btn-sm text-white"
                  onClick={() => setSearchQuery(searchInput)} // ✅ triggers filtering
                  style={style}
                >
                  Search
                </button>
                &nbsp;
                <button
                  onClick={exportToExcel}
                  style={{
                    backgroundColor: "darkblue",
                    color: "#fff",
                    border: "none",
                    borderRadius: "14px",
                    padding: "4px 9px",
                    cursor: "pointer",
                    fontSize: "13px",
                  }}
                >
                  Excel
                </button>
              </div>
            </div>
          </div>

          {/* Table */}
          <div
            className="table-responsive"
            style={{ border: "1px solid #dee2e6", borderTop: "none" }}
          >
            <table className="table table-striped">
              <thead>
                <tr>
                  {tableHeaders.map((h) => (
                    <th key={h}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentRows.length > 0 ? (
                  currentRows.map((log, index) => (
                    <tr key={index}>
                      <td>{indexOfFirstRow + index + 1}</td>
                      <td>{log.FROM_DATE}</td>
                      <td>{log.TO_DATE}</td>
                      <td>{log.CompanyName}</td>
                      <td>{log.Group_id}</td>
                      <td>{log.Address}</td>
                      <td>{log.COUNT}</td>
                      <td>{log.Eng}</td>
                      <td>{log.cuf}</td>
                      <td>{log.pr}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-center my-3">
            <button
              className="btn btn-secondary btn-sm mx-1"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                height: "28px",
                backgroundColor: PrimaryColor,
                padding: "2px",
                fontSize: "10px",
              }}
            >
              Previous
            </button>
            {[...Array(totalPages).keys()].map((num) => (
              <button
                key={num}
                className={`btn btn-sm mx-1 ${
                  currentPage === num + 1 ? "btn-primary" : "btn-outline-primary"
                }`}
                onClick={() => handlePageChange(num + 1)}
                style={{
                  height: "20px",
                  width: "20px",
                  padding: "0",
                  fontSize: "12px",
                }}
              >
                {num + 1}
              </button>
            ))}
            <button
              className="btn btn-secondary btn-sm mx-1"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={{
                height: "28px",
                backgroundColor: PrimaryColor,
                padding: "2px",
                fontSize: "10px",
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

